// deps
import React from "react";

// types
import { PaymentMethod, PaymentMethodMeta, SPLITPAY_POWERED_BY } from "@payment-ui/interfaces";

// components
import SplitPay from "@payment-ui/components/fallback-alert/SplitPay";

// helpers
import { getCloudinaryUrl } from "@swiggy-private/core-ui";

// constants
import { TWID_PAY_ICON } from "@payment-ui/constants";

// styles
import { PaymentMethodContainer } from "./styles";

interface DisabledSplitpayProps {
    paymentMethod: PaymentMethod<PaymentMethodMeta>;
}

/**
 * This is used for disabled splitpay methods/twid rewards
 * Hence,
 * ==> orderAmount is 0
 * ==> onClick is void function
 */
const DisabledSplitpay = ({ paymentMethod }: DisabledSplitpayProps): React.ReactElement => {
    return (
        <PaymentMethodContainer key={paymentMethod.name}>
            <SplitPay
                isSelected={false}
                isDisabled
                inlineMessage={paymentMethod.meta.disableMessage}
                splitPayData={{
                    title: paymentMethod.displayName,
                    swiggyPayEligibleBalance: "0",
                    meta: {
                        iconUrl: paymentMethod.meta.iconUrl ?? "",
                        poweredByLogo:
                            paymentMethod.poweredBy === SPLITPAY_POWERED_BY.TWID
                                ? getCloudinaryUrl(TWID_PAY_ICON, { grayscale: true })
                                : "",
                        poweredBy: paymentMethod.poweredBy,
                    },
                }}
                onClick={() => void 0}
                orderAmount="0"
                isPrimaryPaymentPage
            />
        </PaymentMethodContainer>
    );
};

export default React.memo(DisabledSplitpay);
